import React from 'react';

import { makeStyles } from '@material-ui/styles';
import Popover from '@material-ui/core/Popover';

import LojaSelect from './LojaSelect'


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 2),
    minWidth: 200,
  },
}))

function LojaPicker(props) {
  const { open, anchor, onClose, lojas } = props
  const classes = useStyles()

  return (
    <Popover
      open={open}
      anchorEl={anchor}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      classes={{
        paper: "min-w-220",
      }}
    >
      <div className={classes.root}>
        <LojaSelect lojas={lojas} onClose={onClose} />
      </div>
    </Popover>
  );
}

export default LojaPicker;